<template>
    <div class="partner-hosp">
        <img src="/resource/img/partner-hosp--back01.png" alt="" class="partner-hosp--back01">
        <img src="/resource/img/partner-hosp--back02.png" alt="" class="partner-hosp--back02">
        <ul class="partner-hosp__list">
            <li v-for="hosp in hospJson" class="partner-hosp__item">
                <a :href="hosp.url" class="partner-hosp__link" target="_blank">{{hosp.hospNm}}</a>
            </li>
        </ul>
        <div class="partner-hosp--back03">
           <p>Ewha Womans University Medical Center Cooperative Hospitals</p>
           <p>Ewha Womans University Medical Center Cooperative Hospitals</p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                hospJson: [
                    {hospNm: '감자와눈사람여성의원', url: 'https://www.potatosnow.com/'},
                    {hospNm: '미즈메디병원', url: 'https://mizmedi.com/wweb/main/'},
                    {hospNm: '에이치아이여성의원', url: 'https://www.hifertility.co.kr/index.do'},
                    {hospNm: '미래아이산부인과의원', url: 'http://www.i100.co.kr/'},
                    {hospNm: '밝은미래산부인과의원', url: 'http://www.brightfuture.kr/'},
                    {hospNm: '포미즈여성병원', url: 'http://www.iformiz.co.kr/'},
                    {hospNm: '조은미래산부인과의원', url: 'https://www.choeunmirae.com/'},
                    {hospNm: '서울라헬여성의원', url: 'https://www.rachelivf.com/'},
                    {hospNm: '의료법인성광의료재단일산차병원', url: 'https://ilsan.chamc.co.kr/'},
                    {hospNm: '메디엘라산부인과의원', url: 'https://mediella.com/'},
                    {hospNm: '이화퀸산부인과의원', url: 'http://www.ewhaqueen.co.kr/'},
                    {hospNm: '유광사여성병원', url: 'http://www.yookwangsa.co.kr/index.asp'},
                    {hospNm: '루나여성의원', url: 'https://lunawclinic.modoo.at/'},
                    {hospNm: '이현주산부인과의원', url: 'https//blog.naver.com/joowonobg'},
                    {hospNm: '애플산부인과의원', url: 'https://applewoman.co.kr/'},
                    {hospNm: '최경희산부인과의원', url: 'http://choi-clinic.com/index.asp'},
                    {hospNm: '양미혜산부인과의원', url: 'https://naver.me/5s93dA2'},
                    {hospNm: '목동제일여성병원', url: 'http://mokdongjeil.com/'},
                    {hospNm: '어니스트여성의원', url: 'https://www.honestclinic.com/'},
                    {hospNm: '아란태산부인과의원', url: 'http://www.arante.co.kr/'},
                    {hospNm: '인정병원', url: 'https://injunghp.co.kr/main/main.php'},
                    {hospNm: '의료법인 아인의료재단 아인병원', url: 'https://www.ainwh.co.kr/'},
                    {hospNm: '가톨릭대학교부천성모병원', url: 'https://www.cmcbucheon.or.kr/page/main'},
                    {hospNm: '아름제일병원', url: 'http://www.areumcheil.com/'},
                    {hospNm: '미즈앤미여성의원', url: 'https://blog.naver.com/sbae5'},
                    {hospNm: '목동연세수산부인과의원', url: 'https://blog.naver.com/chung6968'},
                    {hospNm: '라온여성의원', url: 'http://raonclinic.co.kr/'},
                    {hospNm: '인천힘찬종합병원', url: 'https://www.himchangeneral.com/'}
                ]
            }
        },
    }
</script>

<style scoped></style>